import { stableStringify, addFieldDefaults, } from './index.js';
const emptySchema = {
    version: 0,
    collections: {},
};
export function migrate(oldSchemaOrNewSchema, newSchemaOrProcedure, procedureIfTwoSchemas) {
    const isProcedureSecondArgument = typeof newSchemaOrProcedure === 'function';
    const oldSchema = isProcedureSecondArgument
        ? emptySchema
        : oldSchemaOrNewSchema;
    const newSchema = isProcedureSecondArgument
        ? oldSchemaOrNewSchema
        : newSchemaOrProcedure;
    const procedure = isProcedureSecondArgument
        ? newSchemaOrProcedure
        : procedureIfTwoSchemas;
    // diff to determine changed collections
    const changedCollections = Object.keys(newSchema.collections).filter((key) => oldSchema.collections[key] &&
        stableStringify(oldSchema.collections[key]) !==
            stableStringify(newSchema.collections[key]));
    const removedCollections = Object.keys(oldSchema.collections).filter((key) => !newSchema.collections[key]);
    const addedCollections = Object.keys(newSchema.collections).filter((key) => !oldSchema.collections[key]);
    const addedIndexes = {};
    const removedIndexes = {};
    for (const changed of [...changedCollections, ...addedCollections]) {
        const oldIndexes = getIndexes(oldSchema.collections[changed]);
        const newIndexes = getIndexes(newSchema.collections[changed]);
        const added = newIndexes.filter((index) => !oldIndexes.find((i) => i.name === index.name));
        const removed = oldIndexes.filter((index) => !newIndexes.find((i) => i.name === index.name));
        if (added.length > 0) {
            addedIndexes[changed] = added;
        }
        if (removed.length > 0) {
            removedIndexes[changed] = removed;
        }
    }
    return {
        version: newSchema.version,
        migrate: async (engine) => {
            const migratedCollections = [];
            await procedure({
                migrate: async (collection, strategy) => {
                    // @ts-ignore
                    await engine.migrate(collection, strategy);
                    migratedCollections.push(collection);
                },
                identity: (val) => val,
                withDefaults: (collectionName, val) => {
                    return addFieldDefaults(newSchema.collections[collectionName], val);
                },
                info: {
                    changedCollections,
                    addedCollections,
                    removedCollections,
                },
                queries: engine.queries,
                mutations: engine.mutations,
            });
            const unmigrated = changedCollections.filter((collection) => !migratedCollections.includes(collection));
            if (unmigrated.length > 0) {
                console.error('Unmigrated changed collections:', unmigrated);
            }
        },
        removedCollections,
        addedIndexes,
        removedIndexes,
        allCollections: Object.keys(newSchema.collections),
        changedCollections,
        addedCollections,
        oldCollections: Object.keys(oldSchema.collections),
        oldSchema,
        newSchema,
    };
}
export function migrationRange(from, to) {
    return [...Array(to - from).keys()].map((i) => 1 + i + from);
}
function getIndexes(collection) {
    if (!collection)
        return [];
    const fields = Object.keys(collection.fields)
        .filter((key) => collection.fields[key].indexed)
        .map((key) => ({
        name: key,
        multiEntry: collection.fields[key].type === 'array',
        synthetic: false,
        compound: false,
    }));
    return [
        ...fields,
        ...Object.keys(collection.synthetics || {}).map((key) => ({
            name: key,
            multiEntry: ['array', 'string[]', 'number[]', 'boolean[]'].includes(collection.synthetics[key].type),
            synthetic: true,
            compound: false,
        })),
        ...Object.keys(collection.compounds || {}).map((key) => ({
            name: key,
            multiEntry: collection.compounds[key].of.some((fieldName) => (collection.fields[fieldName] || collection.synthetics[fieldName])
                .type === 'array'),
            synthetic: false,
            compound: true,
        })),
    ];
}
export function createDefaultMigration(schema, newSchema) {
    let oldSchema = newSchema
        ? schema
        : {
            version: 0,
            collections: {},
        };
    return migrate(oldSchema, newSchema || schema, async ({ migrate, withDefaults, info }) => {
        if ((newSchema || schema).version === 1)
            return;
        for (const collection of info.changedCollections) {
            // @ts-ignore indefinite type resolution
            await migrate(collection, (old) => withDefaults(collection, old));
        }
    });
}
//# sourceMappingURL=migration.js.map